export default {
    declarations: {
        map: {
            legend: {
                propertyToShow: 'number',
            },
        },
    },
    burns: {
        declarantName: 'Je soussigné(e)',
        declarationId: 'Identifiant du chantier',
    },
}
